/* eslint-disable react/prop-types */
import React, { useState } from 'react';

import { Table } from 'htlib-copy';

import { useGetMissions } from 'hooks/missions';

import AsyncUI from 'components/AsyncUI';
import SimpleCell from 'components/SimpleCell';

import { INITIAL_MISSIONS_QUERY_PARAMS } from './reducer';

import MissionCell from './MissionCell';
import ActionsCell from './ActionsCell';
import Filters from './Filters';

import './index.scss';

export default function Missions() {
  const [missionsQueryParams, setMissionsQueryParams] = useState(INITIAL_MISSIONS_QUERY_PARAMS);

  const getMissionsQuery = useGetMissions(missionsQueryParams, {
    enabled: Boolean(missionsQueryParams),
  });

  const missionsData = getMissionsQuery.data && getMissionsQuery.data.missions;

  const columns = [
    {
      head: 'Mission',
      sortKey: 'missionName',
      className: 'Table__missionName',
      component: MissionCell,
    },
    {
      head: 'Type',
      dataKey: 'labelingType',
      sortKey: 'labelingType',
      className: 'Table__missionType',
    },
    {
      head: 'Status',
      sortKey: 'check.status',
      component: ({ check: { status, update_ongoing: updateOngoing } = {} }) => (
        <SimpleCell value={updateOngoing ? 'refreshing' : status} />
      ),
    },
    {
      head: 'Refreshed',
      sortKey: 'check.refreshed_at',
      component: ({ check: { refreshed_at: refreshedAt } = {} }) => (
        <SimpleCell value={refreshedAt} />
      ),
    },
    {
      head: 'Images',
      sortKey: 'check.nb_images',
      component: ({ check: { nb_images: nbImages } = {} }) => <SimpleCell value={nbImages} />,
    },
    {
      head: 'Tags',
      sortKey: 'check.nb_tags',
      component: ({ check: { nb_tags: nbTags } = {} }) => <SimpleCell value={nbTags} />,
    },
    {
      head: 'Checks',
      sortKey: 'check.nb_checks',
      component: ({ check: { nb_checks: nbChecks } = {} }) => <SimpleCell value={nbChecks} />,
    },
    {
      head: '',
      className: 'Table__actions',
      component: ({ id, check }) => (
        <ActionsCell
          missionId={id}
          hasChecks={Boolean(check)}
          updateOngoing={Boolean(check && check.update_ongoing)}
        />
      ),
    },
  ];

  return (
    <div className="Missions">
      <Filters filters={missionsQueryParams} setFilters={setMissionsQueryParams} />
      <AsyncUI query={getMissionsQuery}>
        <Table
          data={missionsData}
          columns={columns}
          withSort
          initialSort={{ key: 'id', column: 0, type: 'desc' }}
        />
      </AsyncUI>
    </div>
  );
}
